var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartUnavailable(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 408 418.2",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cart-icon",
    d: "M132.6 153c73.2 0 132.6 59.4 132.6 132.6 0 73.2-59.4 132.6-132.6 132.6C59.4 418.2 0 358.8 0 285.6 0 212.4 59.4 153 132.6 153zm86.2 60.8l-158 158c19.5 16.2 44.5 26 71.8 26 62 0 112.2-50.2 112.2-112.2 0-27.3-9.8-52.4-26-71.8zm-86.2-40.4c-62 0-112.2 50.2-112.2 112.2 0 27.3 9.8 52.3 26 71.8l158-158c-19.4-16.2-44.5-26-71.8-26zm211.9 78.4c17.5 0 31.6 14.1 31.6 31.5s-14.2 31.5-31.6 31.5c-17.5 0-31.6-14.1-31.6-31.5h-31.6v-2c0-10.1-1.1-20-3.1-29.5h66.3zM122.1 0c14 0 26.4 9.2 30.4 22.6L164.3 63h220c13.1 0 23.7 10.6 23.7 23.6 0 2.4-.4 4.8-1.1 7.1l-29.8 94.4c-3.1 9.8-12.3 16.5-22.6 16.5h-96c-22.8-35-60.6-59.4-104.3-64.1l-32.1-109H75.8c-8.7 0-15.8-7-15.8-15.7S67.1 0 75.8 0h46.3z"
  })));
}

export default SvgCartUnavailable;